import React from "react";
import Switch from "@material-ui/core/Switch";
import ToggleBtn from "../../ToggleBtn/ToggleBtn";
import styles from "../Events.module.css";

const ToggleSwitch = (props) => {
  const [state, setState] = React.useState(`${props.state}` || "false");
  //  console.log("index: ", props.index, "caching :", state);

  const handleToggle = (event, field) => {
    setState(!state);
  };

  return (
    <div style={{ margin: "auto" }}>
      {/* <Switch
        checked={state}
        onChange={handleChange}
        name="checkedA"
        inputProps={{ "aria-label": "secondary checkbox" }}
      /> */}
      <ToggleBtn
        externalStyling={{
          toggle: styles.toggleclass,
          input: styles.togglechild,
          center: styles.centertoggle,
        }}
        toggleState={state}
        index={props.index}
        handleToggle={handleToggle}
        handleCaching={props.handleCaching}
      ></ToggleBtn>
    </div>
  );
};

export default ToggleSwitch;
